<template>
  <div
    :class="
      pr +
      ` ` +
      pl +
      ` col-12 d-flex justify-content-center justify-content-sm-between flex-wrap`
    "
  >
    <slot name="selectPagination"></slot>
    <el-select
      v-if="showPagination"
      clearable
      @clear="pagination.perPage = 10"
      class="select-default mb-3 shadow-sm"
      style="width: 200px"
      v-model="pagination.perPage"
      :placeholder="$t('common_words.per_page')"
      filterable
    >
      <el-option
        class="select-default"
        v-for="item in pagination.perPageOptions"
        :key="item"
        :label="item"
        :value="item"
      ></el-option>
    </el-select>
    <slot name="between"></slot>
    <div class="d-flex flex-row bd-highlight">
      <div class="mt-1 mr-3 pull-right" v-if="showRefresh">
        <img
          width="35px"
          class="cursors"
          v-tooltip.top-center="$t('common_words.update_data')"
          src="/static/img/iconos/sincronizar.png"
          alt="logo"
          @click="refreshTable()"
        />
      </div>
      <el-input
        v-if="showSearchs"
        clearable
        @clear="searchParentQuery"
        class="mb-3 shadow-sm"
        style="width: 200px"
        :placeholder="$t('common_words.search_records')"
        v-model="searchQuery"
        @keypress.native="searchParentQuery"
        @keyup.delete.native="searchParentQuery"
        @paste.native="searchParentQuery"
        aria-controls="datatables"
      />
    </div>
  </div>
</template>

<script>
import MixinPermissions from 'src/util/mixinPermissions';
import Tables from 'src/class/Tables';

export default {
  name: 'card-header',
  data() {
    return {
      searchQuery: '',
      pagination: this.propPagination
        ? this.propPagination
        : Tables.Table.pagination,
    };
  },
  mixins: [MixinPermissions],
  props: {
    pr: {
      type: String,
      default: '',
    },
    pl: {
      type: String,
      default: '',
    },
    showSearchs: {
      type: Boolean,
      default: true,
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    propPagination: {
      type: Object,
      default: null,
    },
    showRefresh: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    searchParentQuery() {
      setTimeout(() => {
        this.$emit('searchedQuery', this.searchQuery);
      }, 10);
    },
    refreshTable() {
      this.$emit('refreshTable', true);
    },
  },
};
</script>
